import React, {Component} from 'react';
import {connect} from 'react-redux';

class StackItem extends Component {
    getStackView() {
        const {stacking, itemId, players} = this.props;
        const stackItem = stacking.getItem(itemId);

        let content = 'Stack between ';
        content += stackItem.getMinPlayersInPrimaryGroup();
        content += ' and ';
        content += stackItem.getMaxPlayersInPrimaryGroup();
        content += ' of ';

        const playerIds = stackItem.getPlayerIdsInPrimaryGroup();
        const playerNames = playerIds.map((id) => players.getPlayer(id).name);
        content += playerNames.join(', ');

        if (stackItem.isSecondaryGroupUsed()) {
            content += ' between ';
            content += stackItem.getMinPlayersInSecondaryGroup();
            content += ' and ';
            content += stackItem.getMaxPlayersInSecondaryGroup();
            content += ' of ';

            const playerIds = stackItem.getPlayerIdsInSecondaryGroup();
            const playerNames = playerIds.map((id) => players.getPlayer(id).name);
            content += playerNames.join(', ');
        }

        content += ' in ';

        if (stackItem.isStackUsedInAllLineups()) {
            content += ' all lineups';
        } else {
            content += ` min ${stackItem.getMinLineups()} lineups`;
        }

        return content;
    }

    render() {
        const {children} = this.props;
        return (
            <span className="advanced-tag">
                {this.getStackView()}
                {children}
            </span>
        );
    }
}

function mapStatesToProps(state) {
    const {playerCombinationStacking, playersData} = state;
    return {
        stacking: playerCombinationStacking,
        players: playersData.players,
    };
}

export default connect(mapStatesToProps)(StackItem);
